export default __webpack_public_path__ + "static/media/mistakes_bg.14b26acf.png";